import utilsMixin from '../../mixins/utils'

export default class CartProduct {
  constructor ({ id, product, name, quantity, price }) {
    this.id = id || utilsMixin.methods.generateId()
    this.product = product
    this.name = name
    this.quantity = quantity
    this.price = price
  }
}
